// src/pages/PrintedBlinds.js 
// (Assuming this file contains your PrintedBlinds component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import PrintedBlindsContent from './PageComponent/PrintedBlindsContent'

function PrintedBlinds() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Printed Blinds enlighten your space with its colour, design & texture</title>
                <meta
                    name="description"
                    content="Marvel Blinds provides a huge range of printed blinds which can match your interior and enhance your room ; you name it we have it"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/printed-blinds`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Printed Blinds" />
                <meta
                    property="og:description"
                    content="Marvel Blinds provides a huge range of printed blinds which can match your interior and enhance your room ; you name it we have it"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/printed-blinds`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <PrintedBlindsContent />
                <Footer />
            </div>
        </>
    );
}

export default PrintedBlinds;